// Users Store Module
import { createBaseModule } from './base'
import { usersApi } from '@/services/api'

// Custom getters for users
const customGetters = {
  // Filter out invalid users
  validUsers: state => state.items.filter(user => 
    user && 
    typeof user === 'object' &&
    (user.id || user._id) && 
    (user.email || user.name)
  ),

  // Get users by role
  getUsersByRole: state => role => 
    state.items.filter(user => user.role === role || user.role_id === role),

  // Get users by organization
  getUsersByOrg: state => orgId => 
    state.items.filter(user => 
      user.org_id === orgId || 
      user.organization_id === orgId || 
      String(user.org_id) === String(orgId) ||
      String(user.organization_id) === String(orgId)
    )
}

// Create and export the users module
export default createBaseModule('user', usersApi, {
  customGetters
})
